var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import cn from 'classnames';
var Modal = function (props) {
    return _jsx(DialogPrimitive.Root, __assign({}, props));
};
var Content = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, _b = _a.overlayClosable, overlayClosable = _b === void 0 ? true : _b, props = __rest(_a, ["className", "children", "overlayClosable"]);
    var avoidDefaultDownBehavior = function (e) {
        if (!overlayClosable)
            e.preventDefault();
    };
    return (_jsxs(DialogPrimitive.Portal, { children: [_jsx(DialogPrimitive.Overlay, { className: "fixed inset-0 z-50 bg-neutral-500/30 backdrop-blur-sm" }), _jsx("div", __assign({ className: "fixed left-[50%] top-[50%] flex items-center justify-center z-50 px-4 w-full translate-x-[-50%] translate-y-[-50%]" }, { children: _jsx(DialogPrimitive.Content, __assign({ onPointerDownOutside: avoidDefaultDownBehavior, onInteractOutside: avoidDefaultDownBehavior, className: cn('relative max-w-[54.25rem] max-h-[40rem] md:max-h-[37.5rem] overflow-hidden bg-white shadow-l-sm rounded-lg p-6', className) }, props, { ref: ref }, { children: children })) }))] }));
});
Modal.Trigger = DialogPrimitive.Trigger;
Modal.Title = DialogPrimitive.Title;
Modal.Description = DialogPrimitive.Description;
Modal.Content = Content;
Modal.Close = DialogPrimitive.Close;
export default Modal;
//# sourceMappingURL=Modal.js.map